/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `BUYER` - Buyer
 * * `SELLER` - Seller
 */
export type MaterialProductValueType = typeof MaterialProductValueType[keyof typeof MaterialProductValueType];


export const MaterialProductValueType = {
  BUYER: 'BUYER',
  SELLER: 'SELLER',
} as const;
